export default "__VITE_ASSET__b543ee15__"